/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {APP_SHARED} from '../app-shared';
import {MimeTypeKeyPipe} from '../filters/mime-type-key.pipe';

@Component({
  standalone: true,
  imports: [...APP_SHARED, MimeTypeKeyPipe],
  selector: 'adn-mime-type',
  template: `{{ (mimeType | mimeTypeKey) | ogTranslate }}`
})
export class MimeTypeOutputComponent {
  @Input() mimeType: string;
}
